import { render } from "./ProgramOwnerHandoverDetail.vue?vue&type=template&id=72d32b77&scoped=true"
import script from "./ProgramOwnerHandoverDetail.vue?vue&type=script&lang=js"
export * from "./ProgramOwnerHandoverDetail.vue?vue&type=script&lang=js"

import "./ProgramOwnerHandoverDetail.vue?vue&type=style&index=0&id=72d32b77&lang=css"
import "./ProgramOwnerHandoverDetail.vue?vue&type=style&index=1&id=72d32b77&scoped=true&lang=css"

import exportComponent from "/var/www/new_dev_tis/frontend/admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72d32b77"]])

export default __exports__